export default function useTestChecker(dominio) {
	let arr = [
		"mototaxionline.srv.br",
		"logmapp.com.br",
	]

	return arr.includes(dominio)
}